export default __webpack_public_path__ + "static/media/pizza.aac20e52.jpg";